<template>
  <app-layout>
    <div v-if="currentUser">
      <div class="max-w-screen-xl mx-auto p-5">
        <div class="block border-2 rounded border-gray-100">
          <h2
            style="padding-left: 10px"
            class="p-2 border-b-2 border-gray-100 w-full bg-gray-50 block uppercase tracking-wide text-gray-700 text-xs font-bold"
          >
            Projects
          </h2>

          <div v-if="recentError">
            <span class="red mr2"
              >Error while loading data.</span
            >
            <el-button @click="loadRecent()" type="text"
              >Reload</el-button
            >.
          </div>

          <el-table
            :data="recent"
            empty-text="No projects yet"
            v-if="!recentError"
            v-loading="recentLoading"
            style="width: 100%"
          >
            <el-table-column label="Project">
              <template slot-scope="scope">
                <router-link
                  :to="`/project/${scope.row.id}`"
                >
                  <el-button type="text">{{
                    scope.row.label
                      ? scope.row.label
                      : scope.row.id
                  }}</el-button>
                </router-link>
              </template>
            </el-table-column>
            <el-table-column label="Scaffold">
              <template slot-scope="scope">
                <span class="image-icon-small">
                  <span
                    v-html="scope.row.scaffold.header"
                  ></span
                  ><br />
                  Version:
                  <strong class="ml2"
                    ><span
                      v-html="scope.row.scaffold.version"
                    ></span
                  ></strong>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Properties">
              <template slot-scope="scope">
                <div
                  v-for="property in scope.row.presenter
                    .properties"
                  :key="property.label"
                >
                  {{ property.label }}:
                  <strong class="ml2">{{
                    property.value
                  }}</strong>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Entities">
              <template slot-scope="scope">
                <el-tooltip
                  v-for="entity in scope.row.presenter
                    .entities"
                  placement="top"
                  :key="entity.label"
                  :content="entity.value"
                  effect="light"
                >
                  <el-tag
                    type="info"
                    size="mini"
                    class="ml2"
                    >{{ entity.label }}</el-tag
                  >
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="Visited At">
              <template slot-scope="scope">{{
                scope.row.createdAt | dateTime
              }}</template>
            </el-table-column>
            <el-table-column label width="180">
              <template slot-scope="scope">
                <router-link
                  :to="`/project/${scope.row.id}`"
                >
                  <el-button type="text">View</el-button>
                </router-link>

                <el-button
                  class="text-red-500 hover:text-red-400 ml-2"
                  :disabled="destroyLoading"
                  @click="
                    doDestroyWithConfirm(scope.row.id)
                  "
                  type="text"
                  v-if="hasPermissionToDestroy(scope.row)"
                  >Delete</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import { format, parseISO } from 'date-fns';
import { mapGetters } from 'vuex';
import ProjectService from '../project/project-service';
import * as Sentry from '@sentry/browser';

export default {
  name: 'app-project-list',

  data() {
    return {
      recentLoading: true,
      recent: [],
      recentError: false,

      destroyLoading: false,
    };
  },

  filters: {
    dateTime: function(value) {
      return format(parseISO(value), 'yyyy-MM-dd HH:mm');
    },
  },

  async created() {
    const authenticated = await this.authenticatedAsync();

    if (!authenticated) {
      this.$router.push('/');
      return;
    }

    return this.loadRecent();
  },

  computed: {
    ...mapGetters({
      authenticatedAsync: 'auth/authenticatedAsync',
      currentUser: 'auth/currentUser',
      credits: 'credits/credits',
    }),
  },

  methods: {
    async loadRecent() {
      this.recentLoading = true;
      this.recentError = false;
      try {
        this.recent = await ProjectService.listRecent();
        this.recentLoading = false;
      } catch (error) {
        Sentry.captureException(error);
        this.recentLoading = false;
        this.recentError = true;
      }
    },

    hasPermissionToDestroy(row) {
      if (!row) {
        return false;
      }

      return row.userId === this.currentUser.uid;
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          'Are you sure? This operation is irreversible.',
          'Confirm',
          {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'warning',
          },
        );
      } catch (error) {
        return;
      }

      try {
        this.destroyLoading = true;

        await ProjectService.destroy(id);

        this.loadRecent();

        this.destroyLoading = false;
      } catch (error) {
        this.destroyLoading = false;
      }
    },
  },
};
</script>

<style></style>
